import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 17px;
  padding: 5px 10px;

  @media (max-width: 992px) {
    padding: 2px 4px;
  }

  &.left-aligned {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  &.left-aligned-with-padding {
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 1;
  }
  &.new {
    background: ${({ theme }) => theme.old ? 'rgb(234, 234, 234)' : theme.colors.french};
    color: ${({ theme }) => theme.old ? theme.colors.charcoal : theme.colors.white};
  }
  &.sale {
    background: ${({ theme }) => theme.colors.french};
    color: white;
  }
`;

const getProductBadgeType = id => {
  if (id == 1) {
    return 'new';
  }
  if (id == 2) {
    return 'sale';
  }
};

function ProductBadge({
  badgeTreatment,
  leftAligned = false,
  leftAlignedWithPadding = false
}) {
  return (
    <Wrapper
      className={`${getProductBadgeType(badgeTreatment.id)} ${
        leftAligned ? 'left-aligned' : ''
      } ${leftAlignedWithPadding ? 'left-aligned-with-padding' : ''}`}
    >
      {badgeTreatment.name}
    </Wrapper>
  );
}

export default ProductBadge;
